export const wellnessCategoryFullScreenOverlaySx = {
  position: "fixed" as const,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1300,
  bgcolor: "background.paper",
  overflow: "auto",
};
